<div class="delegation-card flex-col" [attr.data-qa-id]="'delegation-card-' + delegation.id">
    <div class="delegation-card-user-info flex-col" [class.fixed-height]="!condensedView">
        <div class="flex-row space-between items-center">
            <span class="delegation-card-field--bold" data-qa-id="delegation-user-name">{{ delegationUser.name }}</span>
            <button class="nova__button--icon delegation-card-edit-button" (click)="editCoverage()" *ngIf="isDelegationOwner">
                <mat-icon>edit</mat-icon>
            </button>
        </div>
        <div class="flex-row items-center">
            <span class="delegation-card-field" data-qa-id="delegation-user-title" *ngIf="delegationUser.title">{{ delegationUser.title }}</span>
            <button class="nova__button--icon" *ngIf="condensedView" (click)="toggleContactInfo()" id="toggle-contact-info-button">
                <mat-icon>{{ isContactInfoHidden ? 'chevron_right' : 'expand_more' }}</mat-icon>
            </button>
        </div>
        <div class="flex-col contact-info" *ngIf="!condensedView || (condensedView && !isContactInfoHidden)">
            <span class="delegation-card-field" data-qa-id="delegation-user-email" *ngIf="delegationUser.email">
                <a
                    class="nova__link"
                    href="mailto:{{ delegationUser.email }}">
                    {{ delegationUser.email }}
                </a>
            </span>
            <span class="delegation-card-field" data-qa-id="delegation-user-phone" *ngIf="delegationUser.phone">{{ delegationUser.phone | phoneFormat }}</span>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div class="delegation-card-permissions flex-col" [class.fixed-height]="!condensedView">
        <span class="delegation-card-field--label">Permissions:</span>
        <ul class="flex-row-wrap space-between items-start" [class.hyperlinked-delegation-types]="!isDelegationOwner" [class.owner-delegation-types]="isDelegationOwner" data-qa-id="delegation-types">
            @for (delegationType of delegation.delegationTypes; track delegationType.key) {
                @if (delegationType.key === delegationTypeEnum.InAppImpersonation) {
                    @if (auth0NovaLinkedProfilesSignal() && auth0NovaImpersonationSignal()) {
                        <li class="delegation-type">
                            @if (isDelegationOwner) {
                                {{ delegationType.value }}
                            } @else if (delegation.ownerAspNetUserId) {
                                <button mat-stroked-button color="secondary" (click)="impersonate(delegation.ownerAspNetUserId)">Impersonate user</button>
                            }
                        </li>
                    }
                }
                @else {
                    <li class="delegation-type">
                        @if (isDelegationOwner) {
                            {{ delegationType.value }}
                        } @else {
                            <a class="nova__link" target="{{ condensedView ? '_self' : '_blank' }}" href="#/in-app-notifications?userId={{delegationUser.aspNetUserId}}">
                                View {{ delegationType.value }}
                            </a>
                        }
                    </li>
                }
            }
        </ul>
    </div>
    <div class="delegation-card-timeframe flex-row space-between items-center">
        <span>
            <span class="delegation-card-field--label">Timeframe:</span>
            <span class="delegation-card-field--bold" data-qa-id="delegation-start-date">
                @if (hasDelegationStartTime) {
                    @if(novaDelegationIsCurrentDelegateUtcFixSignal()) {
                        {{ delegation.delegationStartDate+'Z' | date:'MM/dd/yyyy HH:mm' }} -
                    } @else {
                        {{ delegation.delegationStartDate | lenientDate:'MM/dd/yyyy HH:mm':true }} -
                    }
                } @else {
                    {{ delegation.delegationStartDate | lenientDate:'MM/dd/yyyy':true }} -
                }
                 </span>
            <span *ngIf="delegation.delegationEndDate" class="delegation-card-field--bold" data-qa-id="delegation-end-date">
                @if (hasDelegationEndTime) {
                    @if(novaDelegationIsCurrentDelegateUtcFixSignal()) {
                        {{ delegation.delegationEndDate+'Z' | date:'MM/dd/yyyy HH:mm' }}
                    } @else {
                        {{ delegation.delegationEndDate | lenientDate:'MM/dd/yyyy HH:mm':true }}
                    }
                } @else {
                    {{ delegation.delegationEndDate | lenientDate:'MM/dd/yyyy':true }}
                }
            </span>
            <span *ngIf="!delegation.delegationEndDate" class="delegation-card-field--bold" data-qa-id="delegation-end-date-ongoing">ongoing</span>
            <div *ngIf="!delegation.delegationEndDate && isDelegationOwner" class="help-text">End time not set. End coverage manually or edit timeframe.</div>
        </span>
        <button *ngIf="isDelegationOwner" mat-stroked-button color="secondary" (click)="cancelDelegation()">{{ delegation.isCurrent ? 'END' : 'CANCEL' }}</button>
    </div>
</div>
